import * as React from 'react';
import * as tokenService from '@nexxt/common/firebase/auth/userDetails';
import PageNotFound from '../components/common/noMatchPage/PageNotFound';
const Authorization = (allowedRoles) => (WrappedComponent) => {
    class HOC extends React.Component {
        render() {
            // const user = tokenService.getUserDetails();
            const accessType = tokenService.getAccessType();
            if (allowedRoles.includes(accessType)) {
                return <WrappedComponent {...this.props} />;
            } else {
                return (
                    <PageNotFound message="You are not authorized to access this page. Contact your administrator to request permission to use this page" />
                );
            }
        }
    }

    return HOC;
};

export default Authorization;
